import React, { useContext, useState } from 'react'
import { authContext } from '../../configurations/auth/authContext';
import Input from '../controls/Input';
import { Authenticate } from '../../configurations/crud/authenticationCrud';
import { setLoginInfo } from '../../configurations/auth/setLoginInfo';
import { useFormik } from 'formik';
import * as yup from 'yup'
import { Link, redirect, useNavigate } from 'react-router-dom';
import LodingButton from '../controls/LodingButton';
import { useToast } from '../controls/Toast/ToastService';
import { MdErrorOutline, MdLogin, MdOutlineLock, MdOutlineVisibility, MdOutlineVisibilityOff } from 'react-icons/md';
import { FaUserDoctor } from "react-icons/fa6";
import { FaStethoscope, FaShieldHeart, FaBoltLightning, FaArrowLeftLong } from "react-icons/fa6";
import { Capacitor } from '@capacitor/core';
import Footer from '../base/Footer';
import useGlobalLoader from '../../configurations/useGlobalLoader';

const schema = yup.object().shape({
    userName: yup.string().required("User name is required"),
    password: yup.string().required("Password is required.")
})

export default function Login() {
    const { start, end } = useGlobalLoader()
    const toast = useToast()
    const [isLogin, setIsLogin] = useContext(authContext);
    const [loding, setLoding] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const navigate = useNavigate()

    const { values, handleChange, handleBlur, handleSubmit, errors, touched, isValid } = useFormik({
        initialValues: { userName: "", password: "" },
        validationSchema: schema,
        onSubmit(values) { getlogin(values) }
    })

    const getlogin = async (val) => {
        setLoding(true)
        start()
        try {
            let res = await Authenticate(val.userName, val.password)
            let data = res.data
            if (data && data.result.succeeded) {
                setLoginInfo(JSON.stringify(data))
                setIsLogin(true)
                redirect("/home")
                setLoding(false)
                end()
            } else {
                toast.open(data.result.message, <MdErrorOutline />, "danger")
                setLoding(false)
                end()
            }

        } catch (error) {
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            setLoding(false)
            end()
        }
    }

    if (isLogin) return <h1>Loged In</h1>

    return (
        <div className="min-h-screen w-full bg-slate-100 lg:grid lg:grid-cols-2">
            {/* ---- Brand panel (desktop) ---- */}
            <div className="relative hidden flex-col justify-between overflow-hidden bg-gradient-to-br from-brand-500 via-brand-500 to-blue-800 p-12 text-white lg:flex">
                <div className="absolute -right-24 -top-24 h-96 w-96 rounded-full bg-white/10 blur-2xl" />
                <div className="absolute -left-20 bottom-0 h-80 w-80 rounded-full bg-brand-300/20 blur-2xl" />
                <img src="/assets/images/logo-white.svg" alt="Doctora" className="relative h-9 w-auto" />
                <div className="relative">
                    <h1 className="font-display text-4xl font-extrabold leading-tight">Run your OPD,<br />the modern way.</h1>
                    <p className="mt-4 max-w-md text-white/80">Queue management, live patient flow and fast notes — built for busy clinics.</p>
                    <div className="mt-8 space-y-3 text-sm">
                        <div className="flex items-center gap-3"><span className="grid h-9 w-9 place-items-center rounded-xl bg-white/15"><FaBoltLightning /></span> Real-time live OPD queue</div>
                        <div className="flex items-center gap-3"><span className="grid h-9 w-9 place-items-center rounded-xl bg-white/15"><FaStethoscope /></span> Doctor & reception dashboards</div>
                        <div className="flex items-center gap-3"><span className="grid h-9 w-9 place-items-center rounded-xl bg-white/15"><FaShieldHeart /></span> Secure patient records</div>
                    </div>
                </div>
                <p className="relative text-xs text-white/60">© {new Date().getFullYear()} Doctora OPD</p>
            </div>

            {/* ---- Form ---- */}
            <div className="relative flex min-h-screen flex-col justify-start px-0 lg:justify-center lg:px-10 lg:py-8">
                {/* mobile brand hero */}
                <div className="relative overflow-hidden rounded-b-[2rem] bg-gradient-to-br from-brand-500 via-brand-500 to-blue-800 px-6 pb-16 pt-10 text-white lg:hidden">
                    <div className="absolute -right-12 -top-16 h-52 w-52 rounded-full bg-white/10 blur-2xl" />
                    <Link to="/" className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-xl bg-white/15 px-3 py-1.5 text-sm font-medium text-white/90 transition hover:bg-white/25 active:scale-95">
                        <FaArrowLeftLong /> Back
                    </Link>
                    <img alt="Doctora OPD" src="/assets/images/logo-white.svg" className="relative mt-6 h-9 w-auto animate-fade-up" />
                    <h1 className="relative mt-4 animate-fade-up font-display text-2xl font-extrabold">Welcome back</h1>
                    <p className="relative mt-1 animate-fade-up text-sm text-white/85">Sign in to manage your OPD.</p>
                </div>

                <div className="mx-auto -mt-10 w-full max-w-sm animate-fade-up px-6 sm:px-0 lg:mt-0">
                    <div className="card-surface p-6 sm:p-8 lg:mt-0">
                        <div className="hidden lg:block">
                            <h2 className="font-display text-2xl font-bold text-gray-900">Welcome back</h2>
                            <p className="mt-1 text-sm text-gray-500">Sign in to continue to your dashboard.</p>
                        </div>

                        <form onSubmit={handleSubmit} autoComplete='off' className="mt-6 space-y-5">
                            <div>
                                <label htmlFor="userName" className="mb-1.5 block text-sm font-medium text-gray-700">Mobile no.</label>
                                <Input tabIndex={1} placeholder="Enter mobile no." id="userName"
                                    Icon={<FaUserDoctor />}
                                    value={values.userName} onChange={handleChange} onBlur={handleBlur}
                                    isError={errors.userName && touched.userName} />
                                {errors.userName && touched.userName &&
                                    <p className="mt-1 flex items-center gap-1 text-xs text-red-600">
                                        <MdErrorOutline className="shrink-0 text-sm" /> {errors.userName}
                                    </p>}
                            </div>

                            <div>
                                <div className="mb-1.5 flex items-center justify-between">
                                    <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
                                    <div className="flex gap-1.5 text-sm">
                                        <Link tabIndex={5} to="/create-doctor" className="hyper-link">Register</Link>
                                        <span className="text-gray-300">|</span>
                                        <Link tabIndex={6} to="/forgot" className="hyper-link">Forgot?</Link>
                                    </div>
                                </div>
                                <div className="relative">
                                    <Input tabIndex={2} type={showPassword ? "text" : "password"} id="password" placeholder="Enter password"
                                        Icon={<MdOutlineLock className="text-lg" />}
                                        value={values.password} onChange={handleChange} onBlur={handleBlur}
                                        isError={errors.password && touched.password} />
                                    <button
                                        type="button"
                                        tabIndex={-1}
                                        onClick={() => setShowPassword(pre => !pre)}
                                        title={showPassword ? "Hide password" : "Show password"}
                                        className="absolute right-2 top-1/2 grid h-8 w-8 -translate-y-1/2 place-items-center rounded-lg text-gray-400 transition hover:bg-gray-100 hover:text-gray-600 active:scale-95"
                                    >
                                        {showPassword ? <MdOutlineVisibilityOff className="text-lg" /> : <MdOutlineVisibility className="text-lg" />}
                                        <span className="sr-only">{showPassword ? "Hide password" : "Show password"}</span>
                                    </button>
                                </div>
                                {errors.password && touched.password &&
                                    <p className="mt-1 flex items-center gap-1 text-xs text-red-600">
                                        <MdErrorOutline className="shrink-0 text-sm" /> {errors.password}
                                    </p>}
                            </div>

                            <div className="flex gap-2 pt-1">
                                {!loding ?
                                    <>
                                        <button tabIndex={3} className={!isValid ? "btn-blue-disabled" : "btn-blue"} disabled={!isValid} type='submit'>
                                            <span className="flex items-center justify-center gap-2"><MdLogin className="text-lg" /> Sign in</span>
                                        </button>
                                        <button tabIndex={4} onClick={() => navigate("/")} className="btn-default" type='button'>
                                            <span className="flex items-center justify-center gap-2"><FaArrowLeftLong className="text-sm" /> Back</span>
                                        </button>
                                    </>
                                    :
                                    <LodingButton text={"Signing In.."} />
                                }
                            </div>
                        </form>
                    </div>

                    <p className="mt-6 pb-6 text-center text-sm text-gray-500">
                        <Footer isForLogin={true} />
                    </p>
                </div>
            </div>
        </div>
    )
}